import type { IntlShape } from "react-intl";

import { LocalizedError } from "@/lib/localized-error";
import {
  actingAsCompanyOnOwnContentMessage,
  companyFrozenMessage,
  companyFrozenReaderMessage,
  notActingAsCompanyMessage,
} from "@/lib/share-item";
import { userErrorMessage } from "@/lib/user-error";

/**
 * The sentence for a refused project write (spark#1219): GENESIS001250, 001259 and 001260 get the sentences
 * SHARE uses, everything else the general one. Only an admin acting as the company can reactivate it, so
 * the frozen-company sentence carries the repair for them and states the fact to an access-row writer.
 */
export const projectWriteErrorMessage = (
  intl: IntlShape,
  error: unknown,
  actingAsCompanyId: string | null,
): string =>
  (actingAsCompanyId ? companyFrozenMessage(intl, error) : companyFrozenReaderMessage(intl, error)) ??
  notActingAsCompanyMessage(intl, error) ??
  actingAsCompanyOnOwnContentMessage(intl, error) ??
  userErrorMessage(intl, error);

/** The same sentence for a write whose caller catches and shows it (`localizedMessageOf`). */
export const projectWriteError = (intl: IntlShape, error: unknown, actingAsCompanyId: string | null): LocalizedError =>
  new LocalizedError(projectWriteErrorMessage(intl, error, actingAsCompanyId), { cause: error });
